import { ParticipationClassType } from "./ParticipationClassType.js";
export var RankMetric;
(function (RankMetric) {
    RankMetric["Time"] = "time";
    RankMetric["AgeTime"] = "age_time";
    RankMetric["Distance"] = "distance";
    RankMetric["Altitude"] = "altitude";
    RankMetric["Rounds"] = "rounds";
    RankMetric["Points"] = "points";
    RankMetric["Rank"] = "rank";
    RankMetric["ParticipationsCount"] = "part_count";
})(RankMetric || (RankMetric = {}));
/**
 * Gets the rank metrics that can be selected as the rank value prop of a result list group.
 * @returns {(string)[]}
 */
export const getResultListGroupRankMetrics = () => [RankMetric.Time, RankMetric.AgeTime, RankMetric.Distance, RankMetric.Altitude, RankMetric.Rounds, RankMetric.Points, RankMetric.Rank, RankMetric.ParticipationsCount];
/**
 * Gets the rank metrics that are stored for a participation.
 * @returns {(string)[]}
 */
export const getParticipationRankMetrics = () => [RankMetric.Time, RankMetric.Distance, RankMetric.Altitude, RankMetric.Rounds, RankMetric.Points];
/**
 * Gets the rank metrics that can be chosen when the specified goal metric is selected.
 * @returns {(string)[]}
 */
export const getRankMetricsForGoalMetric = (goalMetric) => {
    if (!goalMetric) {
        return [RankMetric.Distance, RankMetric.Altitude];
    }
    return Object.values(RankMetric).filter(rankMetric => goalMetric !== rankMetric);
};
/**
 * Gets the rank metrics that are stored for a participation that can be selected as the primary rank metric for a participation class with the given type.
 * @returns {(string)[]}
 */
export const getRankMetricsForParticipationClassType = (participationClassType) => {
    switch (participationClassType) {
        case ParticipationClassType.Attendance:
            return [RankMetric.Time, RankMetric.Distance, RankMetric.Altitude, RankMetric.Rounds, RankMetric.Points];
        case ParticipationClassType.VirtualEvent1:
            return [RankMetric.Time, RankMetric.Distance, RankMetric.Altitude];
        case ParticipationClassType.VirtualEvent2:
            return [RankMetric.Time, RankMetric.Distance, RankMetric.Rounds];
    }
    return [RankMetric.Time, RankMetric.Distance, RankMetric.Altitude, RankMetric.Rounds, RankMetric.Points];
};
export const parseRankMetricValue = (metric, value, extended = false) => {
    const isValueUndefined = [null, undefined].includes(value);
    if (isValueUndefined) {
        return '-';
    }
    switch (metric) {
        case RankMetric.Time:
        case RankMetric.AgeTime:
            return extended ? value : value.split('.')[0];
        case RankMetric.Distance:
            // 3 decimals at max to prevent roundings of 0.999 meters which is confusing on result lists
            return (value / 1000).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 3 }) + ' km';
        case RankMetric.Rank:
        case RankMetric.ParticipationsCount:
        case RankMetric.Points:
        case RankMetric.Rounds:
            return `${value ? value : 0}`;
        case RankMetric.Altitude:
            return `${value} m`;
    }
    return '-';
};
//# sourceMappingURL=RankMetric.js.map